import { withStyles } from '@material-ui/core'

import { styles } from './styles'
import { NewPageGeneral as View } from './NewPageGeneral'

export const NewPageGeneral = withStyles(styles)(View)
